import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { AppStorageKey } from 'src/app/static';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-terms-information-modal',
  templateUrl: './terms-information-modal.component.html',
  styleUrls: ['./terms-information-modal.component.scss'],
})
export class TermsInformationModalComponent implements OnInit {

  @Input() signature_url: string;

  user: any;

  hasCustomColors: boolean = false;

  constructor(public modalController : ModalController, private authService:AuthService, private storage: Storage) { }

  ngOnInit() {
    this.authService.user().subscribe((data:any)=>{
      this.user = data;
    });
    this.setCustomColors();
  }

  async setCustomColors(){
    await this.storage.get(AppStorageKey.HasCustomColors).then(
      data => {
        if(data) {
          this.hasCustomColors = data;
        } 
      },
      error => {
        console.log(error);
      }
    );
  }


  closeModal(){
    this.modalController.dismiss();
  }
}
